import React from 'react';
import { useFirestoreConnection } from '../../hooks/useFirestoreConnection';

// Bannière hors ligne — les lectures déjà en cache restent affichées, mais
// une action envoyée hors ligne (ex: confirmer une réservation) reste en
// attente jusqu'au retour de la connexion avant d'aboutir ou d'échouer.
export default function ConnexionBanner() {
  const connected = useFirestoreConnection();
  if (connected) return null;

  return (
    <div style={{
      background: '#E74C3C', color: 'white', textAlign: 'center',
      padding: '0.6rem 1rem', fontSize: '0.85rem', fontWeight: 600,
      borderRadius: 10, marginBottom: '1.25rem',
    }}>
      📵 Hors ligne — les données affichées sont locales. Vos actions seront synchronisées au retour de la connexion.
    </div>
  );
}
